var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipContent),expression:"tooltipContent"},{name:"aha-click",rawName:"v-aha-click",value:(_vm.toggleLeaderboardVisibility),expression:"toggleLeaderboardVisibility"}],staticClass:"leaderboard-visibility-toggle hover-item",class:{
    'active': _vm.isLeaderboardVisible,
    'light': !_vm.isTextColourLight
  },attrs:{"name":"leaderboard-popup-toggle"}},[_c('aha-icon',{attrs:{"name":"trophy-outlined","width":"24","height":"24","viewBox":"0 0 24 24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }